<template>
    <div class="float-left mr-1">
        <b-button 
            variant="primary" 
            @click.stop="abrirModal()"
        >
            <span>
                <i class="fa fa-usd mr-2"></i> Remanejar valor
            </span>
        </b-button>
        <b-modal id="modalInserirSubItem" v-model="mostrarModal" @show="preencherForm()">
            <div slot="modal-title">
                Item do Contrato -
                <b-badge variant="warning">REMANEJAMENTO</b-badge>
            </div>
            <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
            <b-row v-if="mostrarCheckApostilamento">
                <b-col>
                    <b-form-group>
                        <label>
                            <strong>O quê deseja fazer ?</strong>
                        </label>
                        <b-form-radio-group
                            v-model="contratoApostilamento"
                            @change="alternaJustificativa($event)"
                        >
                            <b-form-radio value="0">
                                <strong>
                                    <span class="text-danger">Atualizar</span>
                                </strong>
                            </b-form-radio>
                            <b-form-radio value="1">
                                <strong>
                                    <span class="text-primary">Apostilar</span>
                                </strong>
                            </b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Item a remover</label>
                        <model-list-select
                            :list="itensARemover"
                            option-text="descricao"
                            option-value="itemContratoId"
                            v-model="itemARemover"
                        ></model-list-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Item a receber</label>
                        <model-list-select
                            :list="itensAReceber"
                            option-text="descricao"
                            option-value="itemContratoId"
                            v-model="itemAReceber"
                        ></model-list-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Valor disponivel</label>
                        <money
                            v-model="valorMaximo"
                            v-bind="money"
                            class="form-control text-right"
                            :disabled="true"
                        ></money>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group
                        :state="$v.valor.$error ? false : null"
                        :invalid-feedback="erroValor"
                    >
                        <label>Valor</label>
                        <money
                            v-model="valor"
                            v-bind="money"
                            class="form-control text-right"
                            @input.native="$v.valor.$touch()"
                        ></money>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="apostilamento || this.atualizacaoContrato()">
                <b-col sm="12">
                    <b-form-group>
                        <label>Justificativa {{labelJustificativa}}</label>
                        <b-form-textarea
                            v-model="justificativaApostilamento"
                            :rows="4"
                            @input="$v.justificativaApostilamento.$touch()"
                            :state="
                                $v.justificativaApostilamento.$error
                                    ? false
                                    : null
                            "
                        ></b-form-textarea>
                        <b-form-invalid-feedback>A justificativa {{textoInfoJustificativa}} é obrigatória</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal(true)">Cancelar</b-button>
                <b-button
                    variant="primary"
                    :disabled="desabilitarBtnSalvar"
                    @click.stop="confirmarSalvar()"
                    class="ml-1"
                >Salvar</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>

import ContratosServicos from './../ContratosServicos'
import { situacaoContrato } from '../SituacaoContrato'
import { required, minValue } from 'vuelidate/lib/validators'
import { ModelListSelect } from 'vue-search-select'

export default {
    components: {
        ModelListSelect
    },

    props: {
        contrato: {
            type: Object,
            default: () => ({})
        },

        apostilamento: {
            type: Boolean,
            default: () => false
        }
    },

    data() {
        return {
            erros: [],
            // atualizarTela: false,
            itensARemover: [],
            itemARemover: null,
            itemARemoverEscolhido: null,
            valorMaximo: 0,
            itemAReceber: null,
            valor: 0,
            mostrarModal: false,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            justificativaApostilamento: '',
            contratoApostilamento: null,
            labelJustificativa: '',
            textoInfoJustificativa: ''
        }
    },

    computed: {
        itensAReceber() {
            let itens = []
            if (this.itensARemover != null && this.itensARemover.length > 0) {
                itens = this.itensARemover
                if (this.itemARemover != null) {
                    itens = itens.filter(p => p.itemContratoId != this.itemARemover)
                }
            }
            return itens
        },

        valorMaximoOk() {
            if (this.itemARemoverEscolhido != null) {
                return this.valor <= this.valorMaximo 
            }
            return true
        },

        mostrarCheckApostilamento() {
            return this.atualizacaoContrato() && this.apostilamento
        },

        desabilitarBtnSalvar() {
            return this.$v.$invalid
        },

        erroValor() {
            if (!(this.$v.valor.minValue)) {
                return 'O valor é obrigatorio'
            }
            if (!(this.$v.valor.validaValorMaximo)) {
                return 'O valor deve ser menor ou igual ao valor disponivel'
            }

            return "Valor invalido"
        }
    },

    watch: {
        itemARemover() {
            if (this.itemAReceber === this.itemARemover) {
                this.removerItemAReceber()
            }

            if (this.itemARemover != null) {
                this.itemARemoverEscolhido = this.itensARemover.find(p => p.itemContratoId === this.itemARemover)
                this.valorMaximo = this.itemARemoverEscolhido.saldoValor
            }
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal(limpar=false) {
            this.mostrarModal = false
            if (limpar) {
                this.itemAReceber = null
                this.itemARemover = null
                this.valor = 0
                this.justificativaApostilamento = ''
                this.contratoApostilamento = null
                this.labelJustificativa = ''
                this.textoInfoJustificativa = ''
                this.itemARemoverEscolhido = null
                this.valorMaximo = 0 
            }
        },

        removerItemAReceber() {
            this.itemAReceber = null
        },

        confirmarSalvar() {
            this.$swal({
                title: 'Itens do Contrato',
                html: `Confirma o remanejamento dos itens</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.salvar()
                }
            })
        },
        
        salvar() {
            this.$store.dispatch('addRequest')
            let remanejamentoDto = {
                itemARemoverId: this.itemARemover,
                itemAReceberId: this.itemAReceber,
                valor: this.valor,
                isApostilamento: this.contratoApostilamento == 1 ? true : false,
                justificativaApostilamento: this.justificativaApostilamento
            }

            ContratosServicos.RemanejarValorItens(this.contrato.idContrato, remanejamentoDto).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro atualizado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.fecharModal(true)
                            this.$emit('obterItensAtualizados')
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        preencherForm() {
            this.itensARemover = this.contrato.itensContrato.filter(p => p.status === 1)
        },

        atualizacaoContrato() {
            return (
                (this.$temAcessoView('CONT-ATUALIZAR-00')
                    || this.$temAcessoView('CONT-APOST-05')
                ) 
                && this.situacoesVigenteDistribuido()
            )
        },

        situacoesVigenteDistribuido() {
            return (
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE2 ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_DISTRIBUIDO ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_DISTRIBUIDO
            )
        },

        contratoElaboracao() {
            return (
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_EM_ELABORACAO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_CONCLUIDO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.CONTRATO_DISTRIBUIDO_AGUARDANDO_INTEGRACAO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.CONTRATO_DISTRIBUIDO
                
            )
        },

        aditivarContrato() {
            return (
                this.contrato.idSituacaoContrato ==
                situacaoContrato.INICIADO_ADITIVO_CONTRATO
            )
        },

        justificativaOk() {
            if (this.apostilamento || this.atualizacaoContrato()) {
                return this.justificativaApostilamento !== ''
            }
            return true
        },

        alternaJustificativa(value) {
            this.contratoApostilamento = value
            if (this.contratoApostilamento == 1) {
                this.textoInfoJustificativa = 'do apostilamento'
                this.labelJustificativa = 'Apostilamento'
            } else {
                this.textoInfoJustificativa = ''
                this.labelJustificativa = ''
            }
        },

        verificaTiposAtualizacao() {
            if (
                (this.apostilamento || this.atualizacaoContrato()) &&
                this.contratoApostilamento != null
            ) {
                return true
            } else if (this.contratoElaboracao() || this.aditivarContrato()) {
                return true
            }
            return false
        },
    },

    validations: {
        itemARemover: {
            required
        },

        itemAReceber: {
            required
        },

        valor: {
            required,
            minValue: minValue(0.01),
            validaValorMaximo() {
                return this.valorMaximoOk
            }
        },

        justificativaApostilamento: {
            justificativaOk() {
                return this.justificativaOk()
            }
        },

        contratoApostilamento: {
            verficaTipoAtualizacao() {
                return this.verificaTiposAtualizacao()
            }
        }
    }
}

</script>